import { Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { AnalysisComponent } from './analysis/analysis.component';
import { AppDemoComponent } from './app-demo/app-demo.component';

export const routes: Routes = [
    {
        path: '', component: AppComponent,
        children: [
            { path: '', redirectTo: 'demo', pathMatch: 'full' },
            { path: 'demo', component: HomeComponent },
            { path: 'testing', component: AnalysisComponent },
            { path: 'testing1', component: AppDemoComponent }
        ]
    }
];
